module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c12"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('strong', [_vm._v("c. 500 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("The Book of Job")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Nineteenth-century Scottish historian Thomas Carlyle thought the biblical book of Job, which deals with the perennial problem of life’s injustice, was “one of the grandest things ever written with a pen.” It was axiomatic in Hebrew theology that God rewarded the good and punished the wicked, yet there was no belief in heaven or hell at the time Job was written. It follows, then, that God’s perfect justice must prevail on earth. Yet is it not obvious, as soberly noted in Psalm 73:12, that it is the “ungodly, who prosper in the world”? The book of Job wrestles with this problem without finding an intellectual solution. Job does, however, find something even more important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The book of Job is framed around an ancient folktale. In God’s heavenly court, Satan suggests that Job is pious and upright only because God has blessed him with good fortune. As a test, God permits Satan to inflict upon Job a slew of calamities. His children, servants, and animals are killed, and he is afflicted with terrible boils. Three friends of Job come to comfort him but without success. They try to convince Job that he must have committed some great sin to deserve such grievous punishment. Job, however, holds firm and insists on his own innocence and the greatness of God. Finally, God himself appears and speaks to Job out of a whirlwind. What does Job know about God and his ways? Where was Job when God laid the foundation of the earth and “all the sons of God shouted for joy”? (Job 38:7). Job admits that he has uttered what he did not understand and repents “in dust and ashes.” God then restores Job to prosperity, blesses him with ten new children, and Job dies an old man, “full of days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the end, Job offers no philosophical solution to the mystery of suffering. Indeed, it seems to suggest that no such solution can be found. But by the conclusion of the book Job has received something far more important than intellectual understanding: personal communion with God. In this way, “patient Job” is presented as a model of the person of faith.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img35"
    }
  }, [_c('em', [_vm._v("Job is tormented by demons in this seventh-century engraving by Lucas Vorsterman after Peter Paul Rubens.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/35-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ecclesiastes (c. 300 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul-Making Theodicy (1966)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d95ec17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c12.vue
// module id = 108
// module chunks = 0